<template>
  <div class='footer_bottom'>
    <!-- <van-row >
      <van-col span="24">
        <van-grid :column-num="3">
          <van-grid-item icon="add-o" text="新申请" clickable :to="{name:'Home'}" />
          <van-grid-item icon="manager-o" text="我审批的" :to="{name:'MyApproval'}" />
          <van-grid-item icon="upgrade" text="已提交" :to="{name:'MyFlow'}"/>
        </van-grid>
      </van-col>
      
    </van-row> -->
    <!-- <van-tabbar v-model="current_active" >
      <van-tabbar-item name="Home" icon="home-o" :to="{name:'Home'}">新申请</van-tabbar-item>
      <van-tabbar-item name="MyApproval" icon="manager-o" :to="{name:'MyApproval'}">我审批的</van-tabbar-item>
      <van-tabbar-item name="MyFlow" icon="upgrade" :to="{name:'MyFlow'}">我提交的</van-tabbar-item>
    </van-tabbar> -->
    <mu-container :value.sync="active" class="index_bottom" ripple>
      <mu-bottom-nav>
          <mu-bottom-nav-item value="index" title="首页" icon="account_balance" :to="{name:'Report'}"></mu-bottom-nav-item>
          
          <!-- <mu-bottom-nav-item value="MyApproval" title="我审批的" icon="account_circle" :to="{name:'MyApproval'}"></mu-bottom-nav-item>
          <mu-bottom-nav-item value="MyFlow" title="我提交的" icon="near_me" :to="{name:'MyFlow'}"></mu-bottom-nav-item> -->
          <mu-bottom-nav-item value="Report" title="收入报表" icon="assessment" :to="{name:'IncomeReport'}"></mu-bottom-nav-item>
          <mu-bottom-nav-item value="Report" title="支出报表" icon="assessment" :to="{name:'CostReport'}"></mu-bottom-nav-item>
      </mu-bottom-nav>
    </mu-container>

  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    active: String
  },
  data(){
    return{
      code:'',
      local:window.location.href,
      current_active:this.active,
    }
  },
  created(){
    // this.getCode();
    // this.getReportPremiss()


  },
  methods:{
   
    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.van-tabbar{
  height:90px;
}
.van-tabbar--fixed{
  bottom:0px;

}
.van-tabbar-item{
  font-size:14px;
  margin-bottom:10px;
}
.van-tabbar-item__icon{
  font-size:24px;
  margin-bottom:10px;
}
.footer_bottom{
  background-color: white;
  position:fixed;
  bottom:0px;
  left:0px;
  right:0px;
  margin:0px auto;
  z-index:99;

}
.index_bottom{
  margin:10px auto 20px auto;
  
}
.router-link-active {
    padding-top: 6px;
    padding-bottom: 5px;
    color: #2196f3;
}
.mu-bottom-item-text{
  font-size:16px;

}
</style>
